import React from 'react';
import { Icon } from '@iconify/react';
import { Tooltip } from '@nextui-org/react';
import { EntityTimestampSection } from './EntityTimestampSection';

export interface RendererHeaderProps {
    agentName: string;
    duration: number;
    entityNumber: string;
    timestamp: string;
    isModal: boolean;
    onFullScreenClick: () => void;
    onRefresh?: () => void;
}

export const RendererHeader: React.FC<RendererHeaderProps> = ({
    agentName,
    duration,
    entityNumber,
    timestamp,
    isModal,
    onFullScreenClick,
    onRefresh
}) => {
    return (
        <div className="flex-none pt-3 pl-3 pr-3">
            <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-1 min-w-0 flex-1 pr-[7.5rem]">
                    <Icon icon="mdi:file-document" className="text-blue-600" style={{ width: '22px', height: '22px', flexShrink: 0 }} />
                    <Tooltip content={agentName} placement="top" showArrow>
                        <span className="text-md font-semibold capitalize truncate block min-w-0">{agentName}</span>
                    </Tooltip>
                </div>
            </div>

            {/* Entity and Timestamp */}
            <EntityTimestampSection
                entityNumber={entityNumber}
                agentName={agentName}
                duration={duration}
                timestamp={timestamp}
                isModal={isModal}
                onFullScreenClick={onFullScreenClick}
                onRefresh={onRefresh}
            />
        </div>
    );
};
